import React from 'react';
import styles from './InternalServerError.css';
import StaticNavigation from './StaticPages/StaticNavigation';

const InternalServerError = () => (
  <div>
    <StaticNavigation title="500" />
    <div className={styles.container}>
      <h1 className={styles.header}>Well this is embarrassing&hellip;</h1>
      <h1 className={styles.header}>something went wrong on our end.</h1>
      <p className={styles.pstyle}>
        Please check back shortly. We are working on the issue.
      </p>
    </div>
  </div>
);

export default InternalServerError;



// WEBPACK FOOTER //
// ./src/components/InternalServerError.jsx